// HeadingLogin.js
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import React from "react";
import { Col, Row } from "react-bootstrap";
export var HeadingLogin = function (props) {
    var device = DeviceContext();
    return (React.createElement(Row, { className: "mx-0" },
        React.createElement(Col, { lg: 12, className: "px-0" },
            React.createElement("span", { className: device && device.isDesktop
                    ? "DMsanR_32_700 txt-midnight-blue"
                    : "DMSanBold_24_700 txt-midnight-blue" }, props.title))));
};
